/**
 * Stable ObjectId-shaped identifiers for the demo dataset.
 *
 * Everything in `fixtures.ts` cross-references these constants rather than
 * literal strings, so the relationships between users, pickups, tiers and
 * locations stay consistent. Values are hand-assigned (not random) so a demo
 * session looks identical on every load.
 */

export const SUBSCRIPTION_IDS = {
  vegetables: "6600a1000000000000000001",
  flowers: "6600a1000000000000000002",
  vegetablesAndFlowers: "6600a1000000000000000003",
} as const;

/**
 * Tiers are solidarity pricing levels, not sizes — the same share at three
 * price points, mirroring the real "Tiers and prices for this season" page.
 */
export const TIER_IDS = {
  regular: "6600a2000000000000000001",
  solidarity: "6600a2000000000000000002",
  lowIncome: "6600a2000000000000000003",
  flowers: "6600a2000000000000000004",
  vegetablesAndFlowers: "6600a2000000000000000005",
} as const;

export const LOCATION_IDS = {
  farm: "6600a3000000000000000001",
  malmo: "6600a3000000000000000002",
  lund: "6600a3000000000000000003",
} as const;

export const USER_IDS = {
  admin: "6600a4000000000000000001",
  employee: "6600a4000000000000000002",
  business: "6600a4000000000000000003",
  client: "6600a4000000000000000004",
  member1: "6600a4000000000000000005",
  member2: "6600a4000000000000000006",
  member3: "6600a4000000000000000007",
  member4: "6600a4000000000000000008",
  member5: "6600a4000000000000000009",
  member6: "6600a400000000000000000a",
  member7: "6600a400000000000000000b",
  unassigned: "6600a400000000000000000c",
} as const;

export const PICKUP_IDS = {
  client: "6600a5000000000000000001",
  member1: "6600a5000000000000000002",
  member2: "6600a5000000000000000003",
  member3: "6600a5000000000000000004",
  member4: "6600a5000000000000000005",
  member5: "6600a5000000000000000006",
  member6: "6600a5000000000000000007",
  member7: "6600a5000000000000000008",
} as const;

export const HARVEST_PRODUCT_IDS = {
  carrots: "6600a6000000000000000001",
  potatoes: "6600a6000000000000000002",
  kale: "6600a6000000000000000003",
  leeks: "6600a6000000000000000004",
  beetroot: "6600a6000000000000000005",
  onions: "6600a6000000000000000006",
  squash: "6600a6000000000000000007",
  spinach: "6600a6000000000000000008",
  fennel: "6600a6000000000000000009",
  cabbage: "6600a600000000000000000a",
} as const;

export const HARVEST_LOG_IDS = {
  week28: "6600a7000000000000000001",
  week27: "6600a7000000000000000002",
  week26: "6600a7000000000000000003",
  week25: "6600a7000000000000000004",
} as const;

export const ORDER_IDS = {
  restaurang: "6600a8000000000000000001",
  cafe: "6600a8000000000000000002",
  skola: "6600a8000000000000000003",
} as const;

export const SEASON_ID = "6600a9000000000000000001";

export const EVENT_IDS = {
  harvestFestival: "6600aa000000000000000001",
  soilWorkshop: "6600aa000000000000000002",
} as const;

/**
 * Counter-backed id generator for records created during a demo session.
 * Resets with the module on reload, same as the store itself.
 */
let created = 0;
export function nextDemoId(): string {
  created += 1;
  return `6600ff${String(created).padStart(18, "0")}`;
}
